module.exports = __webpack_public_path__ + "static/media/week.5b5ba501.svg";